namespace Solovis.Site.TrackingHelper {

    //future us problems
    export function dispatchTrackingEvent(name: string, metaData?: Record<string, any>) {
      throw new Error("Not implemented");
    }

    export async function trackElementAs(element: HTMLElement, productTag: string, metaData?: Record<string, any>) {
        const { slugify } = await (window as any).importShim('@solovis/pa-utils');
        element.setAttribute("data-testid", slugify(productTag));
    }

    export function initPendo(pendoUrlRoot, pendoKey) {     
        (function(apiKey){

            // copied directly from Pendo's portal (except for the pendoUrlRoot bit)
            (function(p: any, e:any, n:any, d:any, o?:any){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
            v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                y=e.createElement(n);y.async=!0;y.src= pendoUrlRoot + '/' + apiKey + '/pendo.js';
                z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
        
            const info = (Solovis as any).Info

            const storedValue = window.localStorage.getItem('pa//ux');
            const isUserOptingIntoNewExperience = storedValue ? storedValue === 'true' : false;
            const isNewExperienceActive = isUserOptingIntoNewExperience;

            const baseConfig = {
                excludeAllText: true,
                excludeTitle: true,
                visitor: {
                    id: info.userCode,
                    isNewExperienceActive: isNewExperienceActive
                },
            }

            const initOptions = info.orgRef !== null 
                ? _.assign({}, baseConfig, {account: { id: info.orgRef} }) 
                : baseConfig;

            // due to the non-SPA nature of PA we need to init on every page load 
            (window as any).pendo.initialize(initOptions);

        })(pendoKey);
    }   

}